import { render, staticRenderFns } from "./DiskList.vue?vue&type=template&id=39d7e086&"
import script from "./DiskList.vue?vue&type=script&lang=js&"
export * from "./DiskList.vue?vue&type=script&lang=js&"
import style0 from "./DiskList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports